export default __webpack_public_path__ + "static/media/xmas_2023-cn.e9880afd.jpg";